"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { samePageHash } from "./anchor-scroll.utils";
export function AnchorScroll() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
}
function _temp2() {
  const targetFor = _temp;
  const onClick = event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    const anchor_0 = (event.target as HTMLElement | null)?.closest("a");
    if (!anchor_0) {
      return;
    }
    const target = targetFor(anchor_0);
    if (!target) {
      return;
    }
    event.preventDefault();
    window.history.pushState(null, "", `#${target.id}`);
    target.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      block: "start"
    });
  };
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
}
function _temp(anchor) {
  const hash = samePageHash(anchor.getAttribute("href"), window.location.pathname);
  return hash ? document.getElementById(hash) : null;
}